<template>
  <div class="ivan-setting-page anCore-fill" v-loading="loading">
    <ul class="nav nav-tabs" role="tablist">
      <li :class="{ active: tab === 'basic' }">
        <a href="javascript:;" role="tab" @click.prevent="tab = 'basic'" @mousedown.prevent>
          <span>基本类型</span>
        </a>
      </li>
      <li :class="{ active: tab === 'sub' }">
        <a href="javascript:;" role="tab" @click.prevent="tab = 'sub'" @mousedown.prevent>
          <span>详细类型</span>
        </a>
      </li>
    </ul>

    <div v-show="tab === 'basic'" class="tab-pane table-area">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="min-width:88px;">类型名称</th>
            <th style="width:110px;text-align:center;">
              <button type="button" class="btn btn-success btn-sm" @click="onReadonly">
                <i class="fa fa-plus" />&nbsp;新增
              </button>
            </th>
          </tr>
        </thead>
        <tbody v-if="basicList.length">
          <tr
            v-for="row in basicList"
            :key="row.BasicID"
            :class="{ 'anCore-item-active': selectedId === ('b' + row.BasicID) }"
            @click="selectRow('b' + row.BasicID)"
          >
            <td>{{ row.InspectBasicType }}</td>
            <td>
              <button type="button" class="btn btn-link btn-sm" title="编辑" @click.stop="onReadonly">
                <i class="fa fa-edit" />
              </button>
              <button type="button" class="btn btn-link btn-sm" title="删除" @click.stop="onReadonly">
                <i class="fa fa-trash-o text-muted" />
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="2">
              <div class="text-center text-muted" style="padding:10px 0;">当前暂无数据</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-show="tab === 'sub'" class="tab-pane">
      <div class="row">
        <div class="form-group col-sm-4 has-feedback">
          <div class="input-group">
            <span class="input-group-addon"><span>基本类型</span></span>
            <select class="form-control" v-model="basicFilter">
              <option value="">全部</option>
              <option v-for="b in basicOptions" :key="b" :value="b">{{ b }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="table-area">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th style="min-width:88px;">基本类型</th>
              <th style="min-width:150px;">详细的项目类型</th>
              <th style="min-width:120px;">项目类型编码</th>
              <th style="min-width:60px;">排序</th>
              <th style="width:110px;text-align:center;">
                <button type="button" class="btn btn-success btn-sm" @click="onReadonly">
                  <i class="fa fa-plus" />&nbsp;新增
                </button>
              </th>
            </tr>
          </thead>
          <tbody v-if="filteredSub.length">
            <tr
              v-for="(row, idx) in filteredSub"
              :key="row.SubTypeID || idx"
              :class="{ 'anCore-item-active': selectedId === ('s' + (row.SubTypeID || idx)) }"
              @click="selectRow('s' + (row.SubTypeID || idx))"
            >
              <td>{{ row.InspectBasicType }}</td>
              <td>{{ row.InspectSubType }}</td>
              <td>{{ row.TypeCode }}</td>
              <td>{{ row.Ordinal == null ? '' : row.Ordinal }}</td>
              <td>
                <button type="button" class="btn btn-link btn-sm" title="编辑" @click.stop="onReadonly">
                  <i class="fa fa-edit" />
                </button>
                <button type="button" class="btn btn-link btn-sm" title="删除" @click.stop="onReadonly">
                  <i class="fa fa-trash-o text-muted" />
                </button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5">
                <div class="text-center text-muted" style="padding:10px 0;">当前暂无数据</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { loadIvanSyncJson } from '@/utils/ivanSync'
import ivanSettingList from '@/mixins/ivanSettingList'

export default {
  name: 'InspectTypeSetting',
  mixins: [ivanSettingList],
  data() {
    return {
      loading: false,
      tab: 'basic',
      basicList: [],
      subList: [],
      basicFilter: ''
    }
  },
  computed: {
    basicOptions() {
      const set = {}
      this.basicList.forEach(b => {
        if (b.InspectBasicType) set[b.InspectBasicType] = true
      })
      this.subList.forEach(s => {
        if (s.InspectBasicType) set[s.InspectBasicType] = true
      })
      return Object.keys(set)
    },
    filteredSub() {
      if (!this.basicFilter) return this.subList
      return this.subList.filter(s => s.InspectBasicType === this.basicFilter)
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const [basic, sub] = await Promise.all([
          loadIvanSyncJson('inspect_basic_type.json'),
          loadIvanSyncJson('inspect_sub_type.json')
        ])
        this.basicList = (basic && basic.dataGrid && basic.dataGrid.List) || []
        const fromGrid = (sub && sub.inspectTypeGrid && sub.inspectTypeGrid.List) || []
        this.subList = fromGrid.length ? fromGrid : (sub.subTypeList || [])
      } catch (e) {
        this.$message.error(e.message || '加载项目类型失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.ivan-setting-page {
  height: 100%;
  padding: 8px 12px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.nav-tabs { margin-bottom: 12px; flex: 0 0 auto; }
.nav-tabs > li > a {
  cursor: pointer;
  outline: none !important;
  box-shadow: none !important;
}
.nav-tabs > li > a:focus,
.nav-tabs > li > a:active {
  outline: none !important;
  box-shadow: none !important;
}
.tab-pane { flex: 1 1 auto; min-height: 0; overflow: auto; }
.table-area { overflow: auto; }
.table-area >>> tbody tr,
.tab-pane >>> tbody tr { cursor: pointer; }
.row { margin: 0; }
</style>
